exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InputCheckboxError {\n  margin-top: 4px;\n  color: #de4a4a;\n  font-size: 12px;\n  width: 100%;\n  clear: both;\n  margin-left: 28px; }\n", ""]);

// exports
